import { UseMutationOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  DeleteCommentMutation,
  DeleteCommentMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { EventNames, useTracking } from "lib/tracking";
import { useGraphQlMutation } from "../useGraphQlClient";

const deleteComment = graphql(`
  mutation deleteComment($request: DeleteCommentRequest!) {
    deleteComment(DeleteCommentRequest: $request) {
      id
    }
  }
`);

export function useDeleteComment(
  options?: UseMutationOptions<
    DeleteCommentMutation,
    unknown,
    DeleteCommentMutationVariables,
    unknown
  >,
) {
  const { logEvent } = useTracking();
  const { data, ...rest } = useGraphQlMutation(deleteComment, {
    ...options,
    onSuccess: (data, vars, context) => {
      logEvent(EventNames.commentActioned, {
        "Action type": "deleted",
        "Comment ID": data.deleteComment?.id,
      });
      options?.onSuccess?.(data, vars, context);
    },
  });

  return { data: data?.deleteComment, ...rest };
}
